var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414.06,
    height: 648.56,
    viewBox: "0 0 618 968",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.722 435.93C507.73 364.153 501.476 263.072 436.96 198.539C367.177 128.738 255.261 126.762 183.174 192.942V183.723C183.174 82.313 100.883 0 -0.5 0C-101.883 0 -184.174 82.313 -184.174 183.723V192.942C-256.261 127.091 -368.177 128.738 -437.96 198.539C-502.805 263.402 -509.059 364.153 -456.722 435.93C-547.9 446.466 -619 524.169 -619 618.335C-619 719.745 -536.709 802.058 -435.326 802.058H-426.11L-437.63 813.582C-509.388 885.359 -509.388 1001.58 -437.63 1073.36C-367.518 1143.49 -254.286 1145.14 -182.528 1077.31C-170.678 1167.2 -93.6536 1237 -0.5 1237C92.6536 1237 169.678 1167.53 181.528 1077.31C253.615 1144.81 366.518 1143.49 436.63 1073.36C508.388 1001.58 508.388 885.359 436.63 813.582L425.11 802.058H434.326C535.709 802.058 618 719.745 618 618.335C617.671 524.169 546.901 446.466 455.722 435.93Z",
    fill: "#24EE81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon4);
export default __webpack_public_path__ + "static/media/statisticsIcon4.87072055ed8e8fea2a236dc4025567f1.svg";
export { ForwardRef as ReactComponent };